module.exports = __webpack_public_path__ + "img/mastercard.ce06f23a.svg";